import lorencova from "../images/people/lorencova.jpg";
import nemec from "../images/people/nemec.jpg";
import takumi from "../images/people/takumi.jpg";

export const researchersEn = [
   {
    id: `takumi`,
    name: `Takumi Saito`,
    email: `saito.zef@gmail.com`,
    description: `Takumi Saito received his Ph.D. in 2019 at the Graduate School of Life Sciences, Tohoku University in Tokyo, Japan. Then, he worked at Toho University in Chiba, Japan, as a Postdoctoral Fellowship of Japan Society for the Promotion of Science (JSPS) and also worked at Tohoku University as Postdoctoral Researcher. He has focused on the diversification process of non-marine mollusks in Japan, which is a biodiversity hotspot of non-marine mollusks. In particular, using freshwater mollusks as model systems, he clarified the importance of geographic barriers and dispersal over the barriers to diversification. He is also interested in studying the taxonomy and conservation of Japanese freshwater mollusks, and the spread of non-native species. At Masaryk University, he is studying the biogeography of non-marine mollusks widely distributed in the Northern Hemisphere, particularly the relationship between climate change and diversification.`,
    researchgate: `https://www.researchgate.net/profile/Takumi-Saito-5`,
    is: `https://is.muni.cz/osoba/saito`,
    img: takumi,
  },
  {
    id: `nemec`,
    name: `Tomáš Němec`,
    email: `422930@mail.muni.cz`,
    description: `Tomáš Němec studied Zoology at Masaryk University in Brno, graduating in 2018. During
    Bachelor and Master studies he focused on identifying land snail predators based on empty shell
    analyses. In his Master thesis he compared predation caused by various predators across five
    different habitat types. In graduated from his PhD studies at the Department of Botany and Zoology,
    field Ecology, in 2023. His PhD thesis he focused on the role of land snails in food chains. Apart from
    malacophagous predators, diet of land snails was also evaluated using a specific approach
    consisting in stable isotope analyses.`,
    researchgate: `https://www.researchgate.net/profile/Tomas-Nemec-4`,
    is: `https://is.muni.cz/auth/osoba/422930`,
    img: nemec,
  },
  {
    id: `lorencova`,
    name: `Erika Šlachtová`,
    email: `erikalorencova@mail.muni.cz`,
    description: `Erika Lorencová studied Ecology at Masaryk University in Brno, graduating Bachelor degree in
    2014 with a thesis study the spreading of non-native freshwater molluscs in the Czech Republic.
    Since her Master thesis, defended in 2017, she studied metacommunities of freshwater molluscs
    in lowland stagnant waters. In her PhD thesis, defended in 2022, she was dealing with the wide range distribution of
    molluscs metacommunities in the area from the Czech Republic to Albania with the interest to
    environmental and spatial factors and in the future also the genetic structure of the populations
    of selected species.`,
    researchgate: `https://www.researchgate.net/profile/Erika_Lorencova2`,
    is: `https://is.muni.cz/auth/osoba/393897`,
    img: lorencova,
  },
];

export const researchersCz = [
  {
    id: `takumi`,
    name: `Takumi Saito`,
    email: `saito.zef@gmail.com`,
    description: `Takumi Saito získal titul Ph.D. v roce 2019 na Graduate School of Life Sciences, Tohoku University v Tokiu (Japonsko). Později pracoval na University in Chiba (Japonsko) v rámci postgraduálního programu “Postdoctoral Fellowship of Japan Society for the Promotion of Science (JSPS)” a dále na Tohoku University jako odborný postgraduální pracovník. Zabývá se procesem diverzifikace měkkýšů (vyjma mořských) na území Japonska, které patří mezi místa s extrémně vysokou diverzitou měkkýšů. S využitím sladkovodních měkkýšů jakožto modelových organizmů poukázal na význam geografických bariér a šíření přes tyto bariéry pro diverzifikaci měkkýšů. Zajímá se také o taxonomii a ochranu sladkovodních měkkýšů Japonska a šíření nepůvodních druhů. Na Masarykově Univerzitě se věnuje biogeografii kontinentálních měkkýšů severní polokoule, s důrazem na vztah mezi klimatickou změnou a diverzifikací.`,
    researchgate: `https://www.researchgate.net/profile/Takumi-Saito-54`,
    is: `https://is.muni.cz/osoba/saito`,
    img: takumi,
  },
  {
    id: `nemec`,
    name: `Tomáš Němec`,
    email: `422930@mail.muni.cz`,
    description: `Tomáš Němec vystudoval Zoologii na Masarykově univerzitě v Brně, promoval v roce 2018.
      Během bakalářských a magisterských studií se zaměřoval na studii predátorů suchozemských
      plžů, které lze identifikovat na základě analýz prázdných ulit. Ve své diplomové práci porovnával
      predační chování různých predátorů v pěti odlišných typech biotopů. Své doktorské studium na Ústavu botaniky a zoologie, obor Ekologie, úspěšně ukončil v roce 2023. Jeho práce se zabývala
      úlohou suchozemských plžů v potravních řetězcích. Vyjma predátorů byly hodnoceny rovněž potravní nároky suchozemských plžů, a to především pomocí metody
      spočívající v analýze stabilních izotopů.`,
    researchgate: `https://www.researchgate.net/profile/Tomas-Nemec-4`,
    is: `https://is.muni.cz/auth/osoba/422930`,
    img: nemec,
  },
  {
    id: `lorencova`,
    name: `Erika Šlachtová`,
    email: `erikalorencova@mail.muni.cz`,
    description: `Erika Lorencová studuje Ekologii na Masarykově univerzitě v Brně, Bakalářský stupeň ukončila v
      roce 2014, kdy zpracovala bakalářskou práci na téma šíření nepůvodních sladkovodních
      měkkýšů v České republice. Od magisterského stupně se věnuje studiu metaspolečenstev
      měkkýšů v nížinných stojatých vodách. Ve své disertační práci, obhájené v roce 2022, se zabývala distribucí
      metaspolečenstev sladkovodních měkkýšů na velké škále v oblasti od České republiky až po
      Albánii, a do budoucna pak také genetickou strukturou populací vybraných druhů.`,
    researchgate: `https://www.researchgate.net/profile/Erika_Lorencova2`,
    is: `https://is.muni.cz/auth/osoba/393897`,
    img: lorencova,
  },
];
